import {
  BigDotIcon,
  GKButton,
  GKClientDataGrid,
  GKModal,
  StatusField,
  Typography,
} from "components";
import { GKModalProps } from "utils/commonInterface";
import { extraColumnsField } from "utils/helpers";
import { moneyCommaSeparator } from "utils/MathFunction";

interface TradesOfPortfolioInterface {
  isConverted: boolean;
  id: string;
  nse: string;
  bse: string;
  company: string;
  quantity: number;
  price: number;
  transactionType: string;
  smallcaseStatus: string;
  smallcaseError: any;
  filledQuantity: number;
  orderDate: string;
}

interface Props {
  portfolioData: any;
  allTradesOfPortfolio: TradesOfPortfolioInterface[];
}

const OrderPortfolioTradesModal = ({
  open,
  setOpen,
  allTradesOfPortfolio,
  portfolioData,
}: Props & GKModalProps) => {
  // const [selectedIds, setSelectedIds] = useState([]);

  // const { mutate: handleConvertToTrade, isLoading } = useMutation({
  //   mutationFn: (data: any) =>
  //     axiosInstance.post(
  //       `/model_portfolio/${orderId}/order-manager-trade/${portfolioData?.id}/transaction-convert/`,
  //       data,
  //     ),
  // });

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Portfolio Trades"
      width={"60%"}
      // footer={
      //   <GKButton
      //     variant="contained"
      //     loading={isLoading}
      //     onClick={() => {
      //       handleConvertToTrade({
      //         order_execution_id: selectedIds,
      //       });
      //     }}
      //   >
      //     Add to Trade Book{" "}
      //   </GKButton>
      // }
      footer={
        <GKButton
          variant="outlined"
          color="dark"
          onClick={() => setOpen(false)}
        >
          Close
        </GKButton>
      }
    >
      <GKClientDataGrid
        rows={allTradesOfPortfolio || []}
        name="tradesOfPortfolio"
        density="compact"
        // checkboxSelection={portfolioData?.sendingMode === "Gateway"}
        // rowSelectionModel={selectedIds}
        maxHeight={`calc(100vh - 380px)`}
        pagination={allTradesOfPortfolio?.length > 25}
        // onRowSelectionModelChange={(params) => {
        //   setSelectedIds(params);
        // }}
        initialState={{
          columns: {
            columnVisibilityModel: {
              company: true,
              uniqueCode: true,
              transactionType: true,
              quantity: true,
              price: true,
              isConverted: true,
              executedQuantity: portfolioData?.sendingMode === "Gateway",
              smallcaseStatus: portfolioData?.sendingMode === "Gateway",
              smallcaseError: portfolioData?.sendingMode === "Gateway",
            },
          },
        }}
        columns={[
          {
            ...extraColumnsField("Company Name", "company", 250, 1),
          },
          {
            ...extraColumnsField("NSE/BSE Code", "uniqueCode", 200, 1),
            renderCell: (params) => {
              const { nse, bse } = params?.row;
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography>{nse || "-"}</Typography>
                  <Typography>/</Typography>
                  <Typography>{bse || "-"}</Typography>
                </div>
              );
            },
          },
          {
            ...extraColumnsField("Trans. Type", "transactionType", 120, 1),
            renderCell: (params) => {
              const { transactionType } = params?.row;
              return <StatusField statusString={transactionType} />;
            },
          },
          {
            ...extraColumnsField("Order Qty", "quantity", 0, 1),
            type: "number",
          },
          {
            ...extraColumnsField("Executed Qty", "filledQuantity", 120, 1),
            type: "number",
            renderCell: (item) =>
              item?.row?.smallcaseStatus ? item?.row?.filledQuantity : "-",
          },
          {
            ...extraColumnsField("Price", "price", 100, 1),
            type: "number",
            valueFormatter: (params) => moneyCommaSeparator(params?.value),
          },
          {
            ...extraColumnsField("Status", "smallcaseStatus", 100, 1),
            renderCell: (item) => item?.row?.smallcaseStatus || "-",
          },
          {
            ...extraColumnsField("Added to Trade Book", "isConverted", 150, 1),
            renderCell: (params) => {
              const { isConverted } = params?.row;
              return (
                <Typography
                  display={"flex"}
                  alignItems={"center"}
                  color={
                    isConverted ? "var(--success-700)" : "var(--orange-700)"
                  }
                >
                  <BigDotIcon
                    height={20}
                    width={20}
                    color={
                      isConverted ? "var(--success-700)" : "var(--orange-700)"
                    }
                  />
                  {isConverted ? "Completed" : "Pending"}
                </Typography>
              );
            },
          },
          {
            ...extraColumnsField("Error", "smallcaseError", 200, 1),
            renderCell: (item) => (
              <Typography sx={{ whiteSpace: "normal", fontSize: 12 }}>
                {item?.row?.smallcaseError || "-"}
              </Typography>
            ),
          },
        ]}
      />
    </GKModal>
  );
};

export default OrderPortfolioTradesModal;
